import styled from "styled-components";

export const BackStepButton = styled.div`
  display: flex;
  align-items: center;
  padding: var(--allie-spacing-xs);
  cursor: pointer;
  border-radius: var(--allie-radius-xs);
  border: 1px solid var(--allie-color-neutral-30);
  background: white;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
`;
